import { alert } from 'common/components';
import * as actions from 'common/ui/Actions.js';
import React, { useEffect, useRef } from 'react';
import NotificationSystem from 'react-notification-system';
import { connect } from 'react-redux';

import Spinner from './Spinner.react.js';

const Information = ({ ui, removeNotification, addErrorNotification }) => {
  const notificationSystemRef = useRef(null);

  useEffect(() => {
    window.addEventListener('error', e => {
      let error = {
        colno: e.colno,
        lineno: e.lineno,
        timeStamp: e.timeStamp,
        message: e.message
      };

      if (e.error) {
        error = { ...error, ...e.error, message: e.error.message };
      }

      if (error.message !== 'Script error.') {
        addErrorNotification(error.message, error);
      }
    });
  }, [addErrorNotification]);

  useEffect(() => {
    ui.notifications.forEach(notification => {
      if (!notification.modal) {
        const internalNotification = {
          ...notification,
          position: 'tr',
          onRemove: () => removeNotification(notification)
        };

        notificationSystemRef.current &&
          notificationSystemRef.current.addNotification(internalNotification);
      }
    });
  }, [ui, removeNotification]);

  if (ui.isLoading) {
    return <Spinner />;
  }

  if (ui.notifications.length > 0) {
    ui.notifications
      .filter(notification => notification.modal)
      .forEach(notification => {
        if (notification?.error?.status === 404) {
          notification.title = 'Registro não encontrado!';
          notification.type = 'warning';
        }

        const type = notification.type ?? notification.level ?? 'error';

        alert({
          ...notification,
          type,
          text: notification.message,
          onConfirm: () => removeNotification(notification)
        });
      });
  }

  return <NotificationSystem ref={notificationSystemRef} allowHTML />;
};

function mapStateToProps(state) {
  return {
    ui: state.ui
  };
}

export default connect(mapStateToProps, actions)(Information);
